import { GenderEnum } from '@app/constants/enums/gender';
import { TableRecordType } from '@app/types/generalTypes';
import { SorterResult } from 'antd/lib/table/interface';

export interface BasicTableRow {
  key: number;
  name?: string;
  age?: number;
  address?: string;
  [key: string]: unknown;
}

export interface UserTableRow {
  id: string;
  name: string;
  firstname: string;
  lastname: string;
  userName: string;
  email: string;
  phone: string;
  gender: GenderEnum;
  birthdate: string;
  country: string;
  city: string;
  address1: string;
  address2?: string | '';
  zipcode: number;
  phonePrefix: string;
}

export interface Pagination {
  current?: number;
  pageSize?: number;
  total?: number;
}

export interface QueryTable {
  page: number;
  limit: number;
  total?: number;
  search?: string;
  status?: string[] | number[];
  sortBy?: string;
  projectBy?: string;
  populate?: string;
  department?: string | null;
  createdBy?: string | null;
  responsible?: string | null;
  client?: string | null;
}

export interface FileQueryTable extends QueryTable {
  isImage?: boolean;
}

export interface OrderQueryTable extends QueryTable {
  boat?: string | null;
  date?: string | null;
}

export interface BasicTableData {
  data: BasicTableRow[];
  pagination: Pagination;
}

export interface TreeTableRow extends BasicTableRow {
  children?: TreeTableRow[];
}

export interface TreeTableData extends BasicTableData {
  data: TreeTableRow[];
}

export interface EditableTableData extends BasicTableData {
  data: BasicTableRow[];
}

export const getSortBy = (sorter: SorterResult<TableRecordType>): string | null => {
  if (!sorter.field) return null;
  return `${sorter.field}:${sorter.order === 'ascend' ? 'asc' : 'desc'}`;
};
